/**
 * WOD3D — ACO/WCPA file upload: gold dropzone, drag-drop, preview, remove.
 * ACO re-renders often; we re-hydrate UI without rebinding drag listeners.
 */
(function () {
  if (window.__wod3dUploadDropzone) return;
  window.__wod3dUploadDropzone = true;

  const WRAP_SEL = '.wcpa_type_file, .wcpa_field_wrap.wcpa_upload_custom_1';
  const ICON_SVG = `<svg class="wod3d-dropzone__icon" viewBox="0 0 48 48" width="30" height="30" focusable="false" aria-hidden="true">
      <rect x="8" y="12" width="32" height="24" rx="3.5" fill="none" stroke="currentColor" stroke-width="2.2"/>
      <circle cx="18" cy="20.5" r="2.6" fill="none" stroke="currentColor" stroke-width="2.2"/>
      <path d="M10.5 31.5l8.2-8.2a2.2 2.2 0 0 1 3.1 0L29 30.5l3.2-3.2a2.2 2.2 0 0 1 3.1 0l2.2 2.2" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
  const GLYPH = `<span class="wod3d-dropzone__glyph" aria-hidden="true">${ICON_SVG}</span>`;

  function t(key, fallback) {
    const v = window.wod3dI18n && window.wod3dI18n[key];
    if (typeof v === 'string') {
      const s = v.trim();
      if (s && !/^translation missing/i.test(s) && s !== key) return s;
    }
    return fallback || '';
  }

  function formatBytes(n) {
    const bytes = Number(n) || 0;
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  function fileFieldWrap(el) {
    return el?.closest?.(WRAP_SEL) || null;
  }

  function isPatchUpload(wrap) {
    const handle = String(
      window.wod3dAiAssist?.productHandle ||
        window.wod3dProductHandle ||
        document.body?.dataset?.productHandle ||
        ''
    ).toLowerCase();
    if (/parche-personalizado|creamos-tu-parche/.test(handle)) return true;
    const path = (location.pathname || '').toLowerCase();
    if (/parche-personalizado|creamos-tu-parche/.test(path)) return true;
    const input = wrap.querySelector('input[type="file"]');
    if (input?.id === 'field_file_135946104') return true;
    return false;
  }

  function isPetUpload() {
    const cfg = window.wod3dAiAssist || {};
    if (cfg.petKeychain) return true;
    const handle = String(
      cfg.productHandle || window.wod3dProductHandle || document.body?.dataset?.productHandle || ''
    ).toLowerCase();
    if (/mascota|pet-keychain|llavero-mascota/.test(handle)) return true;
    const tags = Array.isArray(cfg.productTags) ? cfg.productTags : [];
    return tags.some((tag) => /mascota|^pet$|meshy|pet.?keychain/i.test(String(tag)));
  }

  function titleFor(wrap) {
    if (isPetUpload()) return t('uploadDropTitlePet', 'Sube la foto de tu mascota');
    return isPatchUpload(wrap)
      ? t('uploadDropTitlePatch', 'Sube tu parche')
      : t('uploadDropTitleDefault', 'Elegir archivo');
  }

  function fileToken(file) {
    if (!file) return '';
    return `${file.name}:${file.size}:${file.lastModified}`;
  }

  function currentFileToken(wrap) {
    const file = wrap?.querySelector('input[type="file"]')?.files?.[0];
    return fileToken(file) || wrap?.dataset.wod3dExpectToken || '';
  }

  function markAssigning(wrap, token) {
    if (!wrap) return;
    wrap.dataset.wod3dAssigning = '1';
    if (token) wrap.dataset.wod3dExpectToken = token;
    window.clearTimeout(wrap._wodAssignT);
    wrap._wodAssignT = window.setTimeout(() => {
      delete wrap.dataset.wod3dAssigning;
    }, 900);
  }

  function assignFiles(input, fileList) {
    if (!input || !fileList?.length) return false;
    try {
      const dt = new DataTransfer();
      Array.from(fileList).forEach((f) => dt.items.add(f));
      input.files = dt.files;
    } catch (_) {
      return false;
    }
    const wrap = fileFieldWrap(input);
    markAssigning(wrap, fileToken(fileList[0]));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function acoHasStoredFile(wrap) {
    return Boolean(wrap?.querySelector('.wcpa_remove_file, .wcpa_file_list li'));
  }

  function clickAcoRemove(wrap) {
    wrap.querySelectorAll('.wcpa_remove_file').forEach((btn) => {
      try {
        btn.click();
      } catch (_) {}
    });
  }

  function waitUntilAcoEmpty(wrap, timeout = 1800) {
    return new Promise((resolve) => {
      const t0 = Date.now();
      const tick = () => {
        if (!acoHasStoredFile(wrap)) {
          resolve(true);
          return;
        }
        if (Date.now() - t0 > timeout) {
          clickAcoRemove(wrap);
          resolve(false);
          return;
        }
        window.setTimeout(tick, 40);
      };
      tick();
    });
  }

  function clearMaxFileError(wrap) {
    if (!wrap) return;
    wrap.querySelectorAll('.wcpa_field_error p, .wcpa_field_error, .wcpa_error, .wcpa_form_error').forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (!/m[aá]ximo/i.test(text) || !/archivo/i.test(text)) return;
      if (el.matches('p')) el.textContent = '';
      else {
        el.querySelectorAll('p').forEach((p) => {
          if (/m[aá]ximo/i.test(p.textContent) && /archivo/i.test(p.textContent)) p.textContent = '';
        });
      }
    });
  }

  async function replaceExistingUpload(wrap, input, fileList) {
    const files = Array.from(fileList || []);
    if (!wrap || !input || !files.length) return;
    const token = fileToken(files[0]);
    if (!token) return;
    if (wrap.dataset.wod3dReplacing === '1') return;
    if (
      (wrap.dataset.wod3dDoneToken === token || wrap.dataset.wod3dExpectToken === token) &&
      acoHasStoredFile(wrap)
    ) {
      return;
    }

    wrap.dataset.wod3dReplacing = '1';
    wrap.dataset.wod3dExpectToken = token;
    delete wrap.dataset.wod3dClearing;
    delete wrap.dataset.wod3dUploadDone;
    delete wrap.dataset.wod3dDoneToken;
    stopProgressWatch(wrap);
    clickAcoRemove(wrap);
    await waitUntilAcoEmpty(wrap);
    try {
      input.value = '';
    } catch (_) {}
    delete wrap.dataset.wod3dReplacing;
    assignFiles(input, files);
    clearMaxFileError(wrap);
    startProgressWatch(wrap, true);
    syncState(wrap);
    window.setTimeout(() => clearMaxFileError(wrap), 80);
    window.setTimeout(() => clearMaxFileError(wrap), 320);
  }

  function pickReplacement(wrap, input) {
    const picker = document.createElement('input');
    picker.type = 'file';
    picker.accept = input?.accept || 'image/*,.psd,.pdf,.eps,.ai,.indd,.raw';
    picker.setAttribute('tabindex', '-1');
    picker.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;opacity:0;pointer-events:none;';
    picker.addEventListener(
      'change',
      () => {
        const files = Array.from(picker.files || []);
        picker.remove();
        if (!files.length) return;
        replaceExistingUpload(wrap, input, files);
      },
      { once: true }
    );
    document.body.appendChild(picker);
    picker.click();
    window.setTimeout(() => picker.remove(), 120000);
  }

  const progressTimers = new WeakMap();

  function stopProgressWatch(wrap) {
    const rec = progressTimers.get(wrap);
    if (!rec) return;
    window.clearInterval(rec.id);
    progressTimers.delete(wrap);
  }

  function startProgressWatch(wrap, restart) {
    if (!wrap) return;
    if (restart) stopProgressWatch(wrap);
    if (progressTimers.has(wrap)) return;
    const rec = { id: 0, started: performance.now() };
    rec.id = window.setInterval(() => {
      if (!wrap.isConnected) {
        stopProgressWatch(wrap);
        return;
      }
      syncState(wrap);
      const stillGoing =
        wrap.classList.contains('is-wod3d-uploading') ||
        (Boolean(wrap.dataset.wod3dExpectToken) &&
          wrap.dataset.wod3dExpectToken !== wrap.dataset.wod3dDoneToken);
      if (!stillGoing) stopProgressWatch(wrap);
    }, 80);
    progressTimers.set(wrap, rec);
  }

  function readAcoProgress(wrap) {
    if (wrap.querySelector('.wcpa_progressbar span.wcpa_success, .awpca_complete')) return 100;
    const bar = wrap.querySelector('.wcpa_progressbar span');
    if (!bar) return null;
    const w = parseFloat(bar.style.width);
    return Number.isFinite(w) ? Math.max(0, Math.min(100, w)) : null;
  }

  function isUploadComplete(wrap) {
    const p = readAcoProgress(wrap);
    if (p >= 99) return true;
    const item = wrap.querySelector('.wcpa_file_list li');
    if (item && !wrap.querySelector('.wcpa_progressbar_area, .wcpa_progressbar')) return true;
    return false;
  }

  function applyProgress(wrap, pct, uploading, done) {
    wrap.style.setProperty('--wod3d-upload-p', `${Math.max(0, Math.min(100, pct))}%`);
    wrap.classList.toggle('is-wod3d-uploading', Boolean(uploading));
    wrap.classList.toggle('is-wod3d-upload-done', Boolean(done));
  }

  function clearFile(wrap, input) {
    wrap.dataset.wod3dClearing = '1';
    stopProgressWatch(wrap);
    applyProgress(wrap, 0, false);
    delete wrap.dataset.wod3dUploadDone;
    const removeBtns = wrap.querySelectorAll('.wcpa_remove_file');
    if (removeBtns.length) {
      removeBtns.forEach((btn) => btn.click());
    } else if (input) {
      try {
        input.files = new DataTransfer().files;
      } catch (_) {
        /* noop */
      }
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    delete wrap.dataset.wod3dComplexity;
    delete wrap.dataset.wod3dSimplifyMessage;
    document.dispatchEvent(new CustomEvent('wod3d:upload-cleared', { detail: { wrap } }));
  }

  function hasUploadedFile(wrap) {
    if (!wrap) return false;
    const input = wrap.querySelector('input[type="file"]');
    if (input?.files?.length) return true;
    const named = wrap.querySelector(
      '.wcpa_file_list li .wcpa_file_details, .wcpa_file_list li .wcpa_filename, .wcpa_file_list li'
    );
    if (named && named.textContent.trim()) return true;
    const thumb = wrap.querySelector('.wcpa_thumb img[src], .wcpa_file_list img[src]');
    if (thumb?.getAttribute('src')) return true;
    const nativeName = wrap.querySelector('.awpca_custom_file > p')?.textContent?.trim();
    if (nativeName && nativeName.length > 1) return true;
    return false;
  }

  function uploadedMeta(wrap) {
    const input = wrap.querySelector('input[type="file"]');
    const file = input?.files?.[0];
    const fromList =
      wrap.querySelector('.wcpa_file_list .wcpa_file_details span')?.textContent ||
      wrap.querySelector('.wcpa_file_list li')?.textContent ||
      wrap.querySelector('.awpca_custom_file > p')?.textContent ||
      '';
    const thumbSrc =
      wrap.querySelector('.wcpa_thumb img[src], .wcpa_file_list img[src]')?.getAttribute('src') || '';
    const name = (file?.name || fromList || '').replace(/\s+/g, ' ').trim();
    return { name, size: file?.size || 0, file, thumbSrc };
  }

  function findZone(wrap) {
    return wrap.querySelector('.awpca_custom_file') || null;
  }

  function ensureUi(zone, wrap) {
    const field = wrap.querySelector('.wcpa_field') || wrap;
    let ui = wrap.querySelector('.wod3d-dropzone__ui');
    if (ui && ui.parentElement !== field) {
      field.appendChild(ui);
    }
    if (ui) return ui;

    ui = document.createElement('div');
    ui.className = 'wod3d-dropzone__ui';
    ui.innerHTML = `
      <div class="wod3d-dropzone__idle">
        ${GLYPH}
        <p class="wod3d-dropzone__title"></p>
        <p class="wod3d-dropzone__drag"></p>
        <p class="wod3d-dropzone__formats"></p>
      </div>
      <div class="wod3d-dropzone__ready" hidden>
        <div class="wod3d-dropzone__preview-wrap">
          <div class="wod3d-dropzone__preview" aria-hidden="true"></div>
        </div>
        <div class="wod3d-dropzone__meta">
          <p class="wod3d-dropzone__ready-label"></p>
          <p class="wod3d-dropzone__filename"></p>
          <p class="wod3d-dropzone__filesize"></p>
          <div class="wod3d-dropzone__actions">
            <button type="button" class="wod3d-dropzone__replace"></button>
            <button type="button" class="wod3d-dropzone__remove"></button>
          </div>
        </div>
      </div>`;

    field.appendChild(ui);

    const input = wrap.querySelector('input[type="file"]');
    ui.addEventListener('click', (e) => {
      if (e.target.closest('.wod3d-dropzone__replace, .wod3d-dropzone__remove')) return;
      if (wrap.classList.contains('is-wod3d-has-file')) return;
      e.preventDefault();
      e.stopPropagation();
      input?.click();
    });
    ui.querySelector('.wod3d-dropzone__replace')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      pickReplacement(wrap, input);
    });
    ui.querySelector('.wod3d-dropzone__remove')?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearFile(wrap, input);
      window.setTimeout(() => syncState(wrap), 40);
      window.setTimeout(() => syncState(wrap), 220);
    });

    return ui;
  }

  function syncCopy(ui, wrap) {
    if (!ui) return;
    const set = (sel, text) => {
      const el = ui.querySelector(sel);
      if (el && text) el.textContent = text;
    };
    set('.wod3d-dropzone__title', titleFor(wrap));
    const tapCopy = window.matchMedia('(hover: none)').matches;
    set(
      '.wod3d-dropzone__drag',
      tapCopy
        ? t('uploadDropTap', 'Toca para subir tu imagen')
        : t('uploadDropDrag', 'Arrastra tu archivo aquí')
    );
    set('.wod3d-dropzone__formats', t('uploadDropFormats', 'PNG, JPG, PDF, AI, PSD, EPS…'));
    set('.wod3d-dropzone__ready-label', t('uploadDropReady', 'Archivo listo'));
    set('.wod3d-dropzone__replace', t('uploadDropReplace', 'Cambiar archivo'));
    set('.wod3d-dropzone__remove', t('uploadDropRemove', 'Quitar'));
  }

  function previewKey(meta) {
    const file = meta?.file;
    if (file) return `file:${file.name}:${file.size}:${file.lastModified}`;
    if (meta?.thumbSrc && !/^data:,$/.test(meta.thumbSrc)) return `src:${meta.thumbSrc}`;
    if (meta?.name) return `name:${meta.name}`;
    return '';
  }

  function clearPreview(box) {
    if (!box) return;
    box.textContent = '';
    box.classList.remove('is-image', 'is-file', 'is-pdf', 'is-badge');
    if (box._wodUrl) {
      URL.revokeObjectURL(box._wodUrl);
      box._wodUrl = null;
    }
    box._wodKey = '';
    box._wodPending = '';
  }

  function fileExt(fileOrName) {
    const name = typeof fileOrName === 'string' ? fileOrName : fileOrName?.name || '';
    const m = /\.([a-z0-9]+)$/i.exec(name.trim());
    return m ? m[1].toLowerCase() : '';
  }

  function isRasterImageFile(file) {
    if (!file) return false;
    if (/^image\//.test(file.type || '') && !/image\/(vnd\.adobe|x-photoshop|photoshop)/i.test(file.type)) {
      return true;
    }
    return /^(jpe?g|png|gif|webp|bmp|svg|avif|heic|heif|tif|tiff)$/i.test(fileExt(file));
  }

  async function fileStartsWithPdf(file) {
    if (!file || file.size < 5) return false;
    try {
      const buf = await file.slice(0, 5).arrayBuffer();
      const sig = new TextDecoder('ascii').decode(new Uint8Array(buf));
      return sig === '%PDF-';
    } catch (_) {
      return false;
    }
  }

  function formatBadgeLabel(file, meta) {
    const ext = (fileExt(file) || fileExt(meta?.name) || '').toUpperCase();
    if (ext) return ext;
    if (/pdf/i.test(file?.type || '')) return 'PDF';
    if (/photoshop|psd/i.test(file?.type || '')) return 'PSD';
    if (/postscript|eps/i.test(file?.type || '')) return 'EPS';
    return 'FILE';
  }

  function renderFormatBadge(box, label, subtitle) {
    box.innerHTML = `
      <div class="wod3d-dropzone__badge">
        <span class="wod3d-dropzone__badge-ext">${label}</span>
        <span class="wod3d-dropzone__badge-note">${subtitle}</span>
      </div>`;
    box.classList.remove('is-image', 'is-pdf');
    box.classList.add('is-file', 'is-badge');
  }

  function setPdfPreview(box, file, key) {
    const url = URL.createObjectURL(file);
    const frame = document.createElement('iframe');
    frame.className = 'wod3d-dropzone__pdf';
    frame.title = file.name || 'PDF';
    frame.setAttribute('loading', 'lazy');
    frame.onload = () => {
      if (box._wodPending !== key) {
        URL.revokeObjectURL(url);
        return;
      }
      if (box._wodUrl) URL.revokeObjectURL(box._wodUrl);
      box._wodUrl = url;
      box._wodKey = key;
      box._wodPending = '';
    };
    frame.onerror = () => {
      if (box._wodPending !== key) {
        URL.revokeObjectURL(url);
        return;
      }
      URL.revokeObjectURL(url);
      box._wodPending = '';
      box._wodKey = key;
      renderFormatBadge(
        box,
        formatBadgeLabel(file),
        t('uploadDropPreviewUnavailable', 'Vista previa no disponible')
      );
    };
    box._wodPending = key;
    box.textContent = '';
    box.classList.remove('is-image', 'is-file', 'is-badge');
    box.classList.add('is-pdf');
    box.appendChild(frame);
    frame.src = url + '#toolbar=0&navpanes=0&scrollbar=0';
  }

  function setPreview(ui, meta) {
    const box = ui?.querySelector('.wod3d-dropzone__preview');
    if (!box) return;
    const key = previewKey(meta);
    if (!key) {
      clearPreview(box);
      return;
    }
    if (box._wodKey === key) return;
    // Keep the local file preview; ACO's blob thumb would swap the same image and flicker.
    if (box._wodKey && box._wodKey.startsWith('file:') && key.startsWith('src:')) return;

    const file = meta?.file;
    if (file && isRasterImageFile(file)) {
      const url = URL.createObjectURL(file);
      const img = document.createElement('img');
      img.alt = '';
      img.onload = () => {
        if (box._wodPending !== key) {
          URL.revokeObjectURL(url);
          return;
        }
        if (box._wodUrl) URL.revokeObjectURL(box._wodUrl);
        box.textContent = '';
        box._wodUrl = url;
        box._wodKey = key;
        box._wodPending = '';
        box.appendChild(img);
        box.classList.remove('is-file', 'is-pdf', 'is-badge');
        box.classList.add('is-image');
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        if (box._wodPending !== key) return;
        box._wodPending = '';
        box._wodKey = key;
        renderFormatBadge(
          box,
          formatBadgeLabel(file, meta),
          t('uploadDropPreviewUnavailable', 'Vista previa no disponible')
        );
      };
      box._wodPending = key;
      img.src = url;
      return;
    }

    if (file) {
      const ext = fileExt(file);
      const mime = String(file.type || '').toLowerCase();
      const tryPdf =
        ext === 'pdf' ||
        mime === 'application/pdf' ||
        ext === 'ai' ||
        /illustrator|postscript/i.test(mime);

      if (tryPdf) {
        box._wodPending = key;
        Promise.resolve(ext === 'pdf' || mime === 'application/pdf' ? true : fileStartsWithPdf(file)).then(
          (ok) => {
            if (box._wodPending !== key) return;
            if (ok) {
              setPdfPreview(box, file, key);
              return;
            }
            box._wodPending = '';
            box._wodKey = key;
            renderFormatBadge(
              box,
              formatBadgeLabel(file, meta),
              t('uploadDropPreviewDesign', 'Archivo de diseño listo')
            );
          }
        );
        return;
      }

      if (/^(psd|eps|ai|indd|raw|cr2|nef|arw|dng|orf|rw2)$/i.test(ext) || /photoshop|postscript|indesign/i.test(mime)) {
        box._wodKey = key;
        renderFormatBadge(
          box,
          formatBadgeLabel(file, meta),
          t('uploadDropPreviewDesign', 'Archivo de diseño listo')
        );
        return;
      }
    }

    if (meta?.thumbSrc && !/^data:,$/.test(meta.thumbSrc)) {
      const img = document.createElement('img');
      img.alt = '';
      img.onload = () => {
        if (box._wodPending !== key) return;
        if (box._wodUrl) URL.revokeObjectURL(box._wodUrl);
        box._wodUrl = null;
        box.textContent = '';
        box._wodKey = key;
        box._wodPending = '';
        box.appendChild(img);
        box.classList.remove('is-file', 'is-pdf', 'is-badge');
        box.classList.add('is-image');
      };
      img.onerror = () => {
        if (box._wodPending !== key) return;
        box._wodPending = '';
        box._wodKey = key;
        renderFormatBadge(
          box,
          formatBadgeLabel(null, meta),
          t('uploadDropPreviewUnavailable', 'Vista previa no disponible')
        );
      };
      box._wodPending = key;
      img.src = meta.thumbSrc;
      return;
    }

    box._wodKey = key;
    renderFormatBadge(
      box,
      formatBadgeLabel(file, meta),
      t('uploadDropPreviewDesign', 'Archivo de diseño listo')
    );
  }

  function syncState(wrap) {
    const zone = findZone(wrap);
    if (!zone) return;
    zone.classList.add('wod3d-dropzone', 'needsclick');

    const ui = ensureUi(zone, wrap);
    const clearing = wrap.dataset.wod3dClearing === '1';
    const present = hasUploadedFile(wrap);
    const idle = ui.querySelector('.wod3d-dropzone__idle');
    const readyEl = ui.querySelector('.wod3d-dropzone__ready');

    if (clearing && wrap.dataset.wod3dReplacing !== '1') {
      stopProgressWatch(wrap);
      applyProgress(wrap, 0, false);
      wrap.classList.remove('is-wod3d-has-file');
      zone.classList.remove('is-has-file');
      if (idle) idle.hidden = false;
      if (readyEl) readyEl.hidden = true;
      setPreview(ui, null);
      if (!present) delete wrap.dataset.wod3dClearing;
      return;
    }

    if (wrap.dataset.wod3dReplacing === '1') {
      wrap.classList.add('is-wod3d-has-file');
      zone.classList.add('is-has-file');
      if (idle) idle.hidden = true;
      if (readyEl) readyEl.hidden = false;
      stopProgressWatch(wrap);
      return;
    }
    const ready = present || (!clearing && wrap.classList.contains('is-wod3d-has-file'));
    const acoPct = readAcoProgress(wrap);
    const choose = zone.querySelector('.wcpa_choose_button');

    zone.querySelectorAll(':scope > p').forEach((p) => {
      p.classList.add('wod3d-dropzone__native-p');
      p.hidden = true;
      p.setAttribute('aria-hidden', 'true');
    });
    if (choose) {
      choose.hidden = true;
      choose.setAttribute('aria-hidden', 'true');
    }

    syncCopy(ui, wrap);
    wrap.classList.toggle('is-wod3d-has-file', ready);
    zone.classList.toggle('is-has-file', ready);
    wrap.classList.toggle('wod3d-dropzone-wrap--patch', isPatchUpload(wrap));

    if (idle) idle.hidden = ready;
    if (readyEl) readyEl.hidden = !ready;

    const expectingUpload =
      Boolean(wrap.dataset.wod3dExpectToken) &&
      wrap.dataset.wod3dExpectToken !== wrap.dataset.wod3dDoneToken &&
      wrap.dataset.wod3dClearing !== '1';

    if (!ready) {
      // Mobile/ACO can clear input.files briefly while upload starts — keep the ring alive.
      if (expectingUpload) {
        startProgressWatch(wrap);
        const live = progressTimers.get(wrap);
        const ran = live ? performance.now() - live.started : 0;
        const pct = Math.min(92, Math.max(8, (ran / 900) * 100));
        applyProgress(wrap, pct, true, false);
        return;
      }
      stopProgressWatch(wrap);
      applyProgress(wrap, 0, false);
      delete wrap.dataset.wod3dClearing;
      delete wrap.dataset.wod3dUploadDone;
      delete wrap.dataset.wod3dDoneToken;
      delete wrap.dataset.wod3dExpectToken;
      setPreview(ui, null);
      return;
    }

    if (present) delete wrap.dataset.wod3dClearing;

    const meta = uploadedMeta(wrap);
    const nameEl = ui.querySelector('.wod3d-dropzone__filename');
    const sizeEl = ui.querySelector('.wod3d-dropzone__filesize');
    if (nameEl) nameEl.textContent = meta.name || t('uploadDropReady', 'Archivo listo');
    if (sizeEl) {
      sizeEl.textContent = meta.size ? formatBytes(meta.size) : '';
      sizeEl.hidden = !meta.size;
    }
    setPreview(ui, meta);

    const token = currentFileToken(wrap);
    if (token && wrap.dataset.wod3dDoneToken === token) {
      applyProgress(wrap, 100, false, true);
      stopProgressWatch(wrap);
      return;
    }

    if (token && wrap.dataset.wod3dExpectToken && wrap.dataset.wod3dExpectToken !== token) {
      delete wrap.dataset.wod3dDoneToken;
    }

    startProgressWatch(wrap);
    const live = progressTimers.get(wrap);
    const ran = live ? performance.now() - live.started : 0;
    const duration = 900;
    const acoDone = isUploadComplete(wrap);
    const pct = Math.min(100, Math.max(acoPct == null ? 0 : acoPct, (ran / duration) * 100));
    const finished = Boolean(token) && (ran >= duration || (acoDone && ran >= 450));

    if (finished) {
      wrap.dataset.wod3dDoneToken = token;
      wrap.dataset.wod3dExpectToken = token;
      wrap.dataset.wod3dUploadDone = '1';
      applyProgress(wrap, 100, true, true);
      window.setTimeout(() => {
        if (wrap.dataset.wod3dDoneToken !== token) return;
        applyProgress(wrap, 100, false, true);
        stopProgressWatch(wrap);
      }, 520);
      return;
    }

    applyProgress(wrap, Math.max(8, pct), true);
  }

  function bindDrag(wrap, zone, input) {
    if (wrap.dataset.wod3dDzBound === '1') return;
    wrap.dataset.wod3dDzBound = '1';

    let dragDepth = 0;
    const mark = (on) => {
      zone.classList.toggle('is-dragover', on);
      wrap.classList.toggle('is-wod3d-dragover', on);
    };

    const onDragEnter = (e) => {
      e.preventDefault();
      e.stopPropagation();
      dragDepth += 1;
      mark(true);
    };
    const onDragOver = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
      mark(true);
    };
    const onDragLeave = (e) => {
      e.preventDefault();
      e.stopPropagation();
      dragDepth = Math.max(0, dragDepth - 1);
      if (dragDepth === 0) mark(false);
    };
    const onDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      dragDepth = 0;
      mark(false);
      const files = e.dataTransfer?.files;
      if (!files?.length) return;
      if (acoHasStoredFile(wrap) || wrap.classList.contains('is-wod3d-has-file')) {
        replaceExistingUpload(wrap, input, files);
        return;
      }
      if (assignFiles(input, files)) {
        delete wrap.dataset.wod3dUploadDone;
        delete wrap.dataset.wod3dClearing;
        startProgressWatch(wrap, true);
        syncState(wrap);
      }
    };

    [zone, wrap].forEach((el) => {
      el.addEventListener('dragenter', onDragEnter);
      el.addEventListener('dragover', onDragOver);
      el.addEventListener('dragleave', onDragLeave);
      el.addEventListener('drop', onDrop);
    });
  }

  function enhanceWrap(wrap) {
    if (!wrap) return;
    const input = wrap.querySelector('input[type="file"]');
    if (!input) return;

    let zone = findZone(wrap);
    if (!zone) {
      const host = wrap.querySelector('.wcpa_file_style') || wrap.querySelector('.wcpa_field');
      if (!host) return;
      zone = document.createElement('div');
      zone.className = 'awpca_custom_file needsclick';
      host.appendChild(zone);
    }

    const label = wrap.querySelector('label.wcpa_file_style') || input.closest('label');
    if (label) label.classList.add('wod3d-dropzone__label');

    wrap.classList.add('wod3d-dropzone-wrap');
    wrap.dataset.wod3dDz = '1';
    bindDrag(wrap, zone, input);
    syncState(wrap);
    ensureIdeaLink(wrap);
  }

  function interpolate(str, vars) {
    let out = String(str || '');
    Object.keys(vars || {}).forEach((k) => {
      out = out.split('{{ ' + k + ' }}').join(String(vars[k] ?? ''));
      out = out.split('{{' + k + '}}').join(String(vars[k] ?? ''));
    });
    return out;
  }

  function ensureIdeaLink(wrap) {
    const cfg = window.wod3dAiAssist || {};
    const personalizable =
      cfg.personalizable === true ||
      (Array.isArray(cfg.productTags) && cfg.productTags.some((tag) => /personaliz/i.test(String(tag))));
    if (!personalizable || !wrap) return;
    if (wrap.nextElementSibling?.classList.contains('wod3d-idea-wa')) return;
    document.querySelectorAll('.wod3d-idea-wa').forEach((el) => {
      if (!el.previousElementSibling?.classList.contains('wod3d-dropzone-wrap')) el.remove();
    });
    if (document.querySelector('.wod3d-idea-wa')) return;

    const title = String(cfg.productTitle || document.querySelector('.product__title h1')?.textContent || '').trim();
    const prefill = interpolate(
      t(
        'uploadIdeaWhatsappPrefill',
        'Hola, quiero un parche personalizado ({{ product }}) y aún no tengo el diseño.'
      ),
      { product: title }
    );
    const rawBase = String(cfg.whatsappUrl || 'https://wa.me/34603024030').trim() || 'https://wa.me/34603024030';
    let href = rawBase;
    try {
      const url = new URL(rawBase, location.origin);
      url.searchParams.set('text', prefill);
      href = url.toString();
    } catch (_) {
      const sep = rawBase.includes('?') ? '&' : '?';
      href = rawBase + sep + 'text=' + encodeURIComponent(prefill);
    }

    const link = document.createElement('a');
    link.className = 'wod3d-idea-wa';
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = t('uploadIdeaWhatsapp', '¿Solo tienes una idea? Cuéntanosla por WhatsApp →');
    wrap.insertAdjacentElement('afterend', link);
  }

  function enhanceCustomizePanels(root = document) {
    const title = t('customizePanelTitle', 'Personaliza tu pedido');
    const sub = t('customizePanelSub', 'Sube tu diseño y, si quieres, deja notas.');

    root.querySelectorAll?.('.wcpa_wrap')?.forEach((wrap) => {
      if (!(wrap instanceof HTMLElement)) return;
      if (!wrap.querySelector('.recuadro')) return;

      wrap.classList.add('wod3d-customize-panel');

      const hasFileUpload = !!wrap.querySelector(
        'input[type="file"], .wcpa_type_file, .wcpa_upload_custom_1, .wod3d-dropzone-wrap'
      );

      let head = wrap.querySelector(':scope > .wod3d-customize-panel__head');
      if (!head) {
        head = document.createElement('div');
        head.className = 'wod3d-customize-panel__head';
        head.innerHTML =
          '<p class="wod3d-customize-panel__title"></p><p class="wod3d-customize-panel__sub"></p>';
        wrap.insertBefore(head, wrap.firstChild);
      }

      const titleEl = head.querySelector('.wod3d-customize-panel__title');
      const subEl = head.querySelector('.wod3d-customize-panel__sub');
      if (titleEl) titleEl.textContent = title;
      if (subEl) {
        if (hasFileUpload && sub) {
          subEl.textContent = sub;
          subEl.hidden = false;
        } else {
          subEl.textContent = '';
          subEl.hidden = true;
        }
      }
    });
  }

  function scan(root = document) {
    root.querySelectorAll?.(WRAP_SEL)?.forEach(enhanceWrap);
    if (root.matches?.(WRAP_SEL)) enhanceWrap(root);
    enhanceCustomizePanels(root);
  }

  function boot() {
    scan();

    document.addEventListener(
      'change',
      (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
        const wrap = fileFieldWrap(input);
        if (!wrap) return;
        if (wrap.dataset.wod3dReplacing === '1') {
          event.stopPropagation();
          event.stopImmediatePropagation();
          return;
        }
        const incoming = fileToken(input.files?.[0]);
        const sameFile =
          incoming &&
          (incoming === wrap.dataset.wod3dExpectToken || incoming === wrap.dataset.wod3dDoneToken);
        if (
          wrap.dataset.wod3dAssigning !== '1' &&
          !sameFile &&
          input.files?.length &&
          acoHasStoredFile(wrap)
        ) {
          event.stopPropagation();
          event.stopImmediatePropagation();
          replaceExistingUpload(wrap, input, input.files);
          return;
        }
        if (incoming) wrap.dataset.wod3dExpectToken = incoming;
        if (!sameFile) {
          delete wrap.dataset.wod3dUploadDone;
          delete wrap.dataset.wod3dDoneToken;
          startProgressWatch(wrap, true);
        }
        delete wrap.dataset.wod3dClearing;
        syncState(wrap);
        window.setTimeout(() => clearMaxFileError(wrap), 50);
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest?.('.wcpa_remove_file')) return;
        window.setTimeout(() => {
          document.querySelectorAll(WRAP_SEL).forEach((wrap) => {
            if (wrap.dataset.wod3dReplacing === '1') return;
            syncState(wrap);
          });
        }, 80);
      },
      true
    );

    document.addEventListener('wod3d:addons-reset', () => {
      document.querySelectorAll(`${WRAP_SEL}[data-wod3d-dz]`).forEach((wrap) => {
        stopProgressWatch(wrap);
        applyProgress(wrap, 0, false);
        delete wrap.dataset.wod3dDz;
        delete wrap.dataset.wod3dDzBound;
        delete wrap.dataset.wod3dClearing;
        delete wrap.dataset.wod3dUploadDone;
        delete wrap.dataset.wod3dReplacing;
        delete wrap.dataset.wod3dAssigning;
        delete wrap.dataset.wod3dDoneToken;
        delete wrap.dataset.wod3dExpectToken;
        wrap.classList.remove(
          'is-wod3d-has-file',
          'is-wod3d-dragover',
          'is-wod3d-uploading',
          'is-wod3d-upload-done',
          'wod3d-dropzone-wrap',
          'wod3d-dropzone-wrap--patch'
        );
      });
      window.setTimeout(() => scan(), 160);
    });

    const observer = new MutationObserver(() => {
      if (window.__wod3dResettingAddons) return;
      window.clearTimeout(boot._t);
      boot._t = window.setTimeout(() => scan(), 60);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
